module.exports = __webpack_public_path__ + "static/media/logoorange.1cf2126f.png";